import { createAPI } from '../../composable/useAPI';
const api = createAPI();

const BASE = '/api/v2/admin/company';

export const AdminCompanyService = {
  async getList(supplyCompany) {
    const params = supplyCompany ? { supplyCompany } : undefined;
    const res = await api.get(BASE, params ? { params } : undefined);
    return res.data.data;
  },

  async searchByName(q) {
    const res = await api.get(`${BASE}/search`, { params: { q } });
    return res.data.data;
  },

  async register(data) {
    const res = await api.post(BASE, data);
    return res.data.data;
  },

  async registerBulk(dataList) {
    const res = await api.post(`${BASE}/bulk`, dataList);
    return res.data.data;
  },

  async checkId(id) {
    const res = await api.get(`${BASE}/check-id`, { params: { id } });
    return res.data.data;
  },

  async updateContractYear(companySeq, year) {
    const res = await api.patch(`${BASE}/${companySeq}/contract-year`, null, { params: { year } });
    return res.data.data;
  },

  async updateCompany(companySeq, data) {
    const res = await api.put(`${BASE}/${companySeq}`, data);
    return res.data.data;
  },
};
